import { createAction } from "typesafe-actions";
export const setAlert = createAction("KALERT/set", (msg, type) => ({ msg, type }))();
